import { BusinessSubscriptionPlanResponse } from 'contracts/spotdif/BusinessSubscriptionPlanResponse';
import { spotdifApi } from '.';
import { ICreateSubscriptionRequest } from 'contracts/requests/ICreateSubscriptionRequest';
import { CreateSubscriptionResponse } from 'contracts/spotdif/CreateSubscriptionResponse';
import { ICommonResponse } from 'contracts/spotdif/ICommonResponse';
import { IBusinessSubscriptionPlanUpdateRequest } from 'contracts/requests/IBusinessSubscriptionPlanUpdateRequest';
import { ISubscriptionStatusResponse } from 'contracts/spotdif/ISubscripitonStatusResponse';

const subscriptionPlan = spotdifApi.injectEndpoints({
    endpoints: (builder) => ({
        getBusinessSuscriptionPlan: builder.query<BusinessSubscriptionPlanResponse, { id: string; type?: string }>({
            query: ({ id, type }) => {
                return {
                    url: `/payment/industry-plan/${id}?type=${type ?? ''}`,
                    method: 'get',
                };
            },
        }),
        updateBusinessSubscriptionPlan: builder.mutation<ICommonResponse, IBusinessSubscriptionPlanUpdateRequest>({
            query: ({ body, id }) => {
                return {
                    url: `/payment/update-plan/${id}`,
                    method: 'POST',
                    body,
                };
            },
        }),
        createSubscription: builder.mutation<CreateSubscriptionResponse, ICreateSubscriptionRequest>({
            query: (body) => {
                return {
                    url: '/payment/create-subscription',
                    method: 'POST',
                    body,
                };
            },
        }),
        getSubscriptionStatus: builder.query<ISubscriptionStatusResponse, { id: string }>({
            query: ({ id }) => ({
                url: `/payment/subscription-status/${id}`,
                method: 'GET',
            }),
        }),
        cancelSubscription: builder.mutation<ICommonResponse, { id: string }>({
            query: ({ id }) => ({
                url: `/payment/cancel-subscription/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const {
    useGetBusinessSuscriptionPlanQuery,
    useCreateSubscriptionMutation,
    useUpdateBusinessSubscriptionPlanMutation,
    useGetSubscriptionStatusQuery,
    useCancelSubscriptionMutation,
} = subscriptionPlan;
